import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';

//Models
import { Product } from '../../modules/sbsuite/models/product.model'; 
import { ClockIn } from '../../modules/sbsuite/models/clock-in.model';


/**
 * Componente Modal para la selección de productos
 *
 * @export
 * @class ProductsModal
 */
@Component({
  selector: 'page-products-modal',
  templateUrl: 'products.modal.html'
})
export class ProductsModal {

  /**
   * Array seleccionable con los datos de los productos relacionados.
   *
   * @type {Array<any>}
   * @memberof ProductsModal
   */
  products: Array<any> = [];

  /**
   * Fichada objectivo a tratar.
   *
   * @type {ClockIn}
   * @memberof ProductsModal
   */
  clockIn: ClockIn = new ClockIn();


  /**
   * Crea una instancia de ProductsModal:
   *  - Assigna la fichada a partir de los NavParams.
   *  - Prepara el array de productos seleccionables.
   * 
   * 
   * 
   * @param {NavController} navCtrl
   * @param {ViewController} viewCtrl
   * @param {NavParams} _navParams
   * @param {SBSuiteManager} sbSuiteManager
   * @param {TranslateService} translateService
   * @memberof ProductsModal
   */
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private _navParams: NavParams,
    public sbSuiteManager: SBSuiteManager,
    public translateService: TranslateService
  ) {

    this.clockIn = this._navParams.get('data');
    let products = [];
    try{
      products = this.clockIn.getRelatedProducts();
    }catch(e){
      console.warn('Bad nav parameter on Products Modal', e);
    };
    
    if(products){ //Crea un nuevo array seleccionable de los productos
      this.products = products.map(product=>{
        let extProduct = {
          code: product.code,
          name: product.name,
          of: product.of,
          selected: false
        }
        return extProduct;
      });
    }
    else{ //@TODO: Eliminar esta opción, solo para pruebas
      this.products = this.sbSuiteManager.sbSuite.clocking.getMockProducts().map(product=>{
        let extProduct = {
          code: product.code,
          name: product.desc,
          selected: false
        }
        return extProduct;
      });
    }
  }


  /**
   * Marca los productos seleccionados 
   *
   * @memberof ProductsModal
   */
  selectProducts(): void{
    
    let selection = this.products
      .filter(product=>product.selected?true:false)
      .map(product=>product);

      
    this.clockIn.products = selection.map(product=> new Product(product));
    //this.sbSuiteManager.sbSuite.clocking.current.client = 'Cliente A';
    //this.sbSuiteManager.sbSuite.clocking.current.order = '0000A';
    this.viewCtrl.dismiss({clockIn: this.clockIn});
  }

  /**
   * 
   * Indica si hay alguna seleccion. 
   * 
   * En caso negativo deshabilita el botón de aplicar
   *
   * @returns {boolean} True si no hay selección
   * @memberof ProductsModal
   */
  isDisabled(): boolean{
    return this.products.filter(product=> product.selected?true:false).length == 0;
  }

  /**
   * Cierra el modal sin selección
   *
   * @memberof ProductsModal
   */
  dismiss(): void {
    this.sbSuiteManager.sbSuite.clocking.current.manufacturingOrder = '';
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/product/products.modal.ts